<template>
	<div class="rapport-vraag">
		<table cellspacing="0" cellpadding="5" v-show="data.length != 0">
			<tbody>
				<tr v-for="d in data" :key="d.Nummer.toString() + d.IsVraagRow" v-bind:class="{ headerrow: d.IsVraagRow, detailrow: !d.IsVraagRow}" >
					<td class="col-l">{{d.Vraag}}</td>
					<td class="col-m">{{d.Datum}}</td>
					<td class="col-m"><span v-html="d.Antwoord" /></td>
				</tr>
			</tbody>
		</table>
		<div v-if="data.length == 0 && clientnummer != ''">Geen gegevens gevonden voor dit cliëntnummer.</div>
		<button @click="download()" v-show="data.length>0">Download Excel</button>
	</div>
</template>


<script>


export default {
	name: 'rapportsessie',
	props: ['clientnummer'],
	components: {},
  data () {
		return {
			data: []
		}
  },
	methods: {
		getRapport: function() {
			if (this.clientnummer && this.clientnummer != "")
			{
				this.$api.pRapportVraag({
						Clientnummer: this.clientnummer
					})
					.then((response) => {
						this.data = response.data;
						this.$emit("loaddata", response.data.length);
					})
			}
		},
		download: function() {
			if (this.clientnummer && this.clientnummer != "")
			{
				this.$api.pRapportVraagExcel({
						Clientnummer: this.clientnummer
					},"excel")
					.then((response) => {
						this.$api.saveDownload(response.data, 'RapportPerVraag '+this.clientnummer+'.xlsx');
					})
			}
		}
	},
	created: function() {
		this.getRapport();
	},
	watch: {
		clientnummer: function() {
			this.getRapport();
		}
	}
}


</script>


<style scoped>

table {
	width: 100%;
	margin-bottom: 15px;
	border: 1px solid silver;
}

.rapport-vraag {
	margin-top: 10px;
	margin-bottom: 20px;
}

tr, td {
	border-width: 0px;
}

.col-l {
	width: 50%;
}
.col-m {
	width: 25%;
}
.col-r {
	width: 25%;
}

thead {
	background-color: #00B4D1;
	color: #fff;
}

.headerrow {
	background-color: #00B4D1;
	color: #fff;
}

.detailrow:nth-child(even) {background-color: #f2f2f2;}
</style>
